// PUT for the two D2C ops writes (routing switches and the store switch).
// src/Api has generic GET and POST helpers only and the repo rule is not to
// add another wrapper there, so this copies GetRequest's normalisation: the
// envelope fields spread out, with `status` replaced by the HTTP status.
const d2cPut = async (url, body, accessToken) =>
  window.axios
    .put(url, body, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + accessToken,
      },
    })
    .then((result) => ({ ...result.data, status: 200 }))
    .catch((result) => ({ ...result?.response?.data, status: result?.response?.status }));

export default d2cPut;
